// ═══════════════════════════════════════════════════════════════════════════
// 🎴 MEMORY GRID COMPACT - Grid 3-4 colonne di card ricordi
// ═══════════════════════════════════════════════════════════════════════════

import React from 'react';

/**
 * Grid compatta di card ricordi
 *
 * @param {Array} memories - Array di ricordi
 * @param {function} onEdit - Callback per edit
 */
function MemoryGridCompact({ memories, onEdit }) {
  if (!memories || memories.length === 0) {
    return (
      <div style={styles.empty}>
        <p>Nessun ricordo in questa categoria</p>
      </div>
    );
  }

  return (
    <div style={styles.grid}>
      {memories.map((memory) => (
        <div key={memory.id} style={styles.card} onClick={() => onEdit && onEdit(memory)}>
          {/* Foto se presente */}
          {memory.photoUrl && (
            <div style={styles.imageContainer}>
              <img
                src={memory.photoUrl}
                alt={memory.title}
                style={styles.image}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
          )}

          {/* Contenuto */}
          <div style={styles.content}>
            <h4 style={styles.title}>
              {memory.title || 'Senza titolo'}
            </h4>
            <p style={styles.description}>
              {memory.description ? memory.description.substring(0, 80) + '...' : 'Nessuna descrizione'}
            </p>
            {memory.date && (
              <p style={styles.date}>
                {new Date(memory.date).toLocaleDateString('it-IT')}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// 🎨 STYLES
// ═══════════════════════════════════════════════════════════════════════════

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
    gap: '16px',
  },

  card: {
    background: '#FFFFFF',
    border: '1px solid #E5E5E5',
    borderRadius: '8px',
    overflow: 'hidden',
    cursor: 'pointer',
    transition: 'all 200ms',
    ':hover': {
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      transform: 'translateY(-2px)',
    },
  },

  imageContainer: {
    width: '100%',
    height: '160px',
    background: '#F5F5F5',
    overflow: 'hidden',
  },

  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },

  content: {
    padding: '16px',
  },

  title: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#171717',
    margin: '0 0 8px 0',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },

  description: {
    fontSize: '13px',
    color: '#737373',
    margin: '0 0 8px 0',
    lineHeight: '1.4',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },

  date: {
    fontSize: '12px',
    color: '#A3A3A3',
    margin: 0,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },

  empty: {
    padding: '32px',
    textAlign: 'center',
    color: '#A3A3A3',
    fontSize: '14px',
    fontStyle: 'italic',
  },
};

export default MemoryGridCompact;
